import team_img_1 from "../../assets/images/team/team-1.jpg"
import team_img_2 from "../../assets/images/team/team-2.jpg"
import team_img_3 from "../../assets/images/team/team-3.jpg"
import team_img_4 from "../../assets/images/team/team-4.jpg"
import team_img_5 from "../../assets/images/team/team-5.jpg"
import team_img_6 from "../../assets/images/team/team-6.jpg"
import team_img_7 from "../../assets/images/team/team-7.jpg"
import team_img_8 from "../../assets/images/team/team-8.jpg"

export const teamData = [
    {
        id: 1,
        src: team_img_1,
        name: "Bonnie Acosta",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/",
                icon: 'ri-facebook-circle-line'
            },
            {
                id: 2,
                link: "https://twitter.com/",
                icon: 'ri-twitter-x-line'
            },
            {
                id: 3,
                link: "https://www.instagram.com/",
                icon: 'ri-instagram-line'
            },
            {
                id: 4,
                link: "https://www.pinterest.com/",
                icon: 'ri-pinterest-line'
            },

        ],
        position: "Lead Developer"
    },
    {
        id: 2,
        src: team_img_2,
        name: "Warren Riner",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/",
                icon: 'ri-facebook-circle-line'
            },
            {
                id: 2,
                link: "https://twitter.com/",
                icon: 'ri-twitter-x-line'
            },
            {
                id: 3,
                link: "https://www.instagram.com/",
                icon: 'ri-instagram-line'
            },
            {
                id: 4,
                link: "https://www.pinterest.com/",
                icon: 'ri-pinterest-line'
            },

        ],
        position: "CEO & Founder"
    },
    {
        id: 3,
        src: team_img_3,
        name: "Helen Kurt",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/",
                icon: 'ri-facebook-circle-line'
            },
            {
                id: 2,
                link: "https://twitter.com/",
                icon: 'ri-twitter-x-line'
            },
            {
                id: 3,
                link: "https://www.instagram.com/",
                icon: 'ri-instagram-line'
            },
            {
                id: 4,
                link: "https://www.pinterest.com/",
                icon: 'ri-pinterest-line'
            },

        ],
        position: "Developer"
    },
    {
        id: 4,
        src: team_img_4,
        name: "Wanda Wagner",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/",
                icon: 'ri-facebook-circle-line'
            },
            {
                id: 2,
                link: "https://twitter.com/",
                icon: 'ri-twitter-x-line'
            },
            {
                id: 3,
                link: "https://www.instagram.com/",
                icon: 'ri-instagram-line'
            },
            {
                id: 4,
                link: "https://www.pinterest.com/",
                icon: 'ri-pinterest-line'
            },

        ],
        position: "CO-Founder"
    },
    {
        id: 5,
        src: team_img_5,
        name: "Paula Vines",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/",
                icon: 'ri-facebook-circle-line'
            },
            {
                id: 2,
                link: "https://twitter.com/",
                icon: 'ri-twitter-x-line'
            },
            {
                id: 3,
                link: "https://www.instagram.com/",
                icon: 'ri-instagram-line'
            },
            {
                id: 4,
                link: "https://www.pinterest.com/",
                icon: 'ri-pinterest-line'
            },

        ],
        position: "CO-Founder"
    },
    {
        id: 6,
        src: team_img_6,
        name: "Judy Mickey",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/",
                icon: 'ri-facebook-circle-line'
            },
            {
                id: 2,
                link: "https://twitter.com/",
                icon: 'ri-twitter-x-line'
            },
            {
                id: 3,
                link: "https://www.instagram.com/",
                icon: 'ri-instagram-line'
            },
            {
                id: 4,
                link: "https://www.pinterest.com/",
                icon: 'ri-pinterest-line'
            },

        ],
        position: "Lead Developer"
    },
    {
        id: 7,
        src: team_img_7,
        name: "Beverly Medellin",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/",
                icon: 'ri-facebook-circle-line'
            },
            {
                id: 2,
                link: "https://twitter.com/",
                icon: 'ri-twitter-x-line'
            },
            {
                id: 3,
                link: "https://www.instagram.com/",
                icon: 'ri-instagram-line'
            },
            {
                id: 4,
                link: "https://www.pinterest.com/",
                icon: 'ri-pinterest-line'
            },

        ],
        position: "Developer"
    },
    {
        id: 8,
        src: team_img_8,
        name: "Julie Barnett",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/",
                icon: 'ri-facebook-circle-line'
            },
            {
                id: 2,
                link: "https://twitter.com/",
                icon: 'ri-twitter-x-line'
            },
            {
                id: 3,
                link: "https://www.instagram.com/",
                icon: 'ri-instagram-line'
            },
            {
                id: 4,
                link: "https://www.pinterest.com/",
                icon: 'ri-pinterest-line'
            },

        ],
        position: "CO-Founder"
    },
]